import React from 'react';
import InlineCropper from '../InlineCropper';

function PhotoUploadSection({
  isCropping,
  tempImage,
  onCropComplete,
  onCropCancel,
  photoPreview,
  onEdit,
  saving,
  downloading,
  onRemove,
  onPhotoChange,
}) {
  return (
                <div className="form-group">
                  <label>
                    Background Photo *
                    <span
                      style={{
                        fontSize: '12px',
                        color: '#718096',
                        fontWeight: 'normal',
                        marginLeft: '8px',
                      }}
                    >
                      (Upload a team or field photo)
                    </span>
                  </label>
                  {isCropping ? (
                    <InlineCropper
                      imageSrc={tempImage}
                      onCropComplete={onCropComplete}
                      onCancel={onCropCancel}
                    />
                  ) : photoPreview ? (
                    <div className="background-photo-preview">
                      <img src={photoPreview} alt="Background" />
                      <button
                        type="button"
                        className="btn-edit-photo-overlay"
                        onClick={onEdit}
                        disabled={saving || downloading}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="btn-remove-background-photo"
                        onClick={onRemove}
                        disabled={saving || downloading}
                      >
                        ✕ Remove
                      </button>
                    </div>
                  ) : (
                    <label
                      htmlFor="background-photo"
                      className="background-photo-upload-btn"
                    >
                      <span>📸 Upload Background Photo</span>
                      <input
                        id="background-photo"
                        type="file"
                        accept="image/jpeg,image/jpg,image/png"
                        onChange={onPhotoChange}
                        style={{ display: 'none' }}
                        disabled={saving || downloading}
                      />
                    </label>
                  )}
                </div>
  );
}

export default PhotoUploadSection;
